import { render, staticRenderFns } from "./PassportCZNIndicatorEditBox.vue?vue&type=template&id=70f6d94c&scoped=true"
import script from "./PassportCZNIndicatorEditBox.vue?vue&type=script&lang=js"
export * from "./PassportCZNIndicatorEditBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f6d94c",
  null
  
)

export default component.exports